/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getPublicAmazonProductVariants.internal

import features.getPublicAmazonProductVariants.models.PublicRewardResponseModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class GetPublicAmazonProductVariantsRequest : NetworkRequest() {

    suspend fun getPublicAmazonProductVariants(
        overrideHeaders: Map<String, String>? = null,
        rewardSlug: String,
        externalProductId: String
    ): IOResult<PublicRewardResponseModel> {
        return safeNetworkCall {
            get(
                endpoint = GetPublicAmazonProductVariantsEndpoint.replaceInPath(
                    PathParameter("rewardSlug", rewardSlug),
                    PathParameter("externalProductId", externalProductId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
